/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InternalVisualizationAPI
 * @hideconstructor
 */
define([], () => {
	class InternalVisualizationAPI {

		/**
		 * @description Get the list of search filters
		 * @function InternalVisualizationAPI#getSearchFilterList
		 * @public
		 * @return list of search filters
		 */
		getSearchFilterList() {}

		/**
		 * @description Get isPreview flag to indicate if the widget is preview widget.
		 * @function InternalVisualizationAPI#isPreview
		 *
		 * @return true if the widget is a preview widget.
		 */
		isPreview() {}

		/**
		 * @description Determine whether the visualization is a predict preview
		 * @function InternalVisualizationAPI#isPredictPreview
		 * @return true if the widget is a predict preview visualization, otherwise false.
		 */
		isPredictPreview() {}

		/**
		 * @description Validate the local filter to ensure all filters are referring to an existing valid column
		 * @function InternalVisualizationAPI#validateLocalFilters
		 */
		validateLocalFilters() {}

		/**
		 * @description Inform visualization of maximum width it can render to. This is for cases
		 * where the visualization's render area is not constrained by the widget size, e.g. when
		 * printing.
		 * @private
		 * 
		 * @function InternalVisualizationAPI#setExtendedRenderWidth
		 * @param {number} extendedRenderWidth in px
		 */
		setExtendedRenderWidth() {}

		/**
		 * @description Get visualization's maximum width it can render to if not constrained by
		 * widget size, e.g. when printing.
		 * @private
		 * 
		 * @function InternalVisualizationAPI#getExtendedRenderWidth
		 * @returns number, representing px
		 */
		getExtendedRenderWidth() {}
	}

	return InternalVisualizationAPI;
});
